module.exports = __webpack_public_path__ + "img/embankment.18c860cc.svg";